module.exports = __webpack_public_path__ + "static/img/Team_spirit4.f03a8b0.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/Team_spirit4.png
// module id = SLst
// module chunks = 0